import styled, { css } from 'styled-components';

import { media } from '~/src/common/theme/deprecated';
import {
  CATALOG_SIDE_PADDING,
  CATALOG_SIDE_PADDING_V2,
} from '~/src/screens/App/CatalogLayout/layout';

// Dans le cas d'une utilisation de ce composant sur une page n'ayant pas
// les marges du catalogue, l'affichage ne fonctionnera pas correctement.
// Il faut alors simuler ces marges via un container autour du swiper.
const simulatedCatalogPadding = css`
  padding-left: calc(env(safe-area-inset-left, 0px) + ${CATALOG_SIDE_PADDING}px);
  padding-right: calc(env(safe-area-inset-right, 0px) + ${CATALOG_SIDE_PADDING}px);

  ${media.XL`
    padding-left: calc(env(safe-area-inset-left, 0px) + ${CATALOG_SIDE_PADDING_V2}px);
    padding-right: calc(env(safe-area-inset-right, 0px) + ${CATALOG_SIDE_PADDING_V2}px);
  `}
`;

export const Container = styled.section<{ $simulateCatalogPadding?: boolean }>`
  max-width: 100%;
  ${p => (p.$simulateCatalogPadding ? simulatedCatalogPadding : '')}
`;
